import { emrFormDefinition } from './emr-forms';
export const EMR_NOT_NEEDED_KEYS = ['prescription', 'lab_order', 'radiology_order', 'procedure_order'];
export function isEmrNotNeededKey(key) {
    return EMR_NOT_NEEDED_KEYS.includes(key);
}
export const VITALS_NOT_TAKEN_REASON_MIN = 3;
export const VITALS_NOT_TAKEN_REASON_MAX = 300;
export const COMPLAINT_HISTORY_NOTE_KEYS = [
    'presentingComplaints',
    'historyOfPresentIllness',
    'pastHistory',
    'surgicalHistory',
    'familyHistory',
    'socialHistory',
    'drugHistory',
];
export const PLAN_NOTE_KEYS = ['treatmentPlan', 'advice'];
export const EMR_REQUIRED_FORMS_MISSING = 'Fill in the required forms before closing the consultation';
export const EMR_REQUIRED_FORMS_PATH = 'requiredForms';
function hasText(value) {
    return typeof value === 'string' && value.trim() !== '';
}
function anyNote(notes, keys) {
    return keys.some((key) => hasText(notes?.[key]));
}
export function rosFindingsRecorded(notes) {
    const findings = notes?.rosFindings;
    const marked = findings !== null && typeof findings === 'object' && Object.keys(findings).length > 0;
    return marked || hasText(notes?.reviewOfSystems);
}
const orderedOrWaived = (count, key, facts) => count > 0 || facts.notNeeded.includes(key);
const COMPLETION_RULES = {
    vitals: (facts) => facts.vitalsCount > 0 || hasText(facts.vitalsNotTakenReason),
    complaint_history: (facts) => hasText(facts.chiefComplaint) || anyNote(facts.notes, COMPLAINT_HISTORY_NOTE_KEYS),
    review_of_systems: (facts) => rosFindingsRecorded(facts.notes),
    examination: (facts) => hasText(facts.notes?.examination),
    diagnosis: (facts) => facts.diagnosesCount > 0,
    plan_follow_up: (facts) => anyNote(facts.notes, PLAN_NOTE_KEYS) || Boolean(facts.followUpDate),
    prescription: (facts) => orderedOrWaived(facts.prescriptionsCount, 'prescription', facts),
    lab_order: (facts) => orderedOrWaived(facts.labOrdersCount, 'lab_order', facts),
    radiology_order: (facts) => orderedOrWaived(facts.radiologyOrdersCount, 'radiology_order', facts),
    procedure_order: (facts) => orderedOrWaived(facts.procedureOrdersCount, 'procedure_order', facts),
};
export function emrFormHasCompletionRule(key) {
    return key in COMPLETION_RULES || emrFormDefinition(key)?.kind === 'clinical_form';
}
export function emrFormFilled(key, facts) {
    const rule = COMPLETION_RULES[key];
    if (rule)
        return rule(facts);
    if (emrFormDefinition(key)?.kind === 'clinical_form')
        return facts.recordedForms.includes(key);
    return false;
}
export function emrProgress(forms, facts) {
    const required = forms.filter((form) => form.enabled && form.required);
    const missing = required.filter((form) => !emrFormFilled(form.key, facts)).map((form) => form.key);
    return { required: required.length, done: required.length - missing.length, missing };
}
export function missingRequiredForms(forms, facts) {
    return emrProgress(forms, facts).missing;
}
export function requiredFormsFromDetails(details) {
    const prefix = `${EMR_REQUIRED_FORMS_PATH}.`;
    return details.flatMap((detail) => (detail.path?.startsWith(prefix) ? [detail.path.slice(prefix.length)] : []));
}
//# sourceMappingURL=emr-completion.js.map